module.exports = __webpack_public_path__ + "static/img/naturalCircle0h.b2f4233.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle0h.svg
// module id = CHCy
// module chunks = 1